import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** Round "Shop by age" tiles or pastel picture tiles: listed tiles (ages, categories or links), else the store's categories. */
export const schema: ComponentSchema = {
  type: 'category-bento',
  label: 'Shop by age / category tiles',
  description: 'Round picture tiles on pastel circles (shop by age), or pastel picture tiles for categories.',
  supportedPages: CONTENT_PAGES,
  variants: [
    { id: 'v1', label: 'Round tiles (shop by age)' },
    { id: 'v2', label: 'Pastel picture tiles (3 / 6 per row)' },
  ],
  commonFields: [
    ...headingFields({
      eyebrow: { en: 'Just the right fit', bn: 'বয়স অনুযায়ী' },
      title: { en: 'Shop by age', bn: 'বয়স দেখে কিনুন' },
      subtitle: 'Toys and gear picked for every stage, from first cuddles to school days.',
    }),
    {
      key: 'tiles',
      label: 'Tiles',
      type: 'array',
      help: 'Empty = the store’s categories. Link each age to its listing, e.g. the Age range filter or a category.',
      itemSchema: [
        { key: 'categoryId', label: 'Category', type: 'category-select', help: 'Sets the link, name and picture unless filled below.' },
        { key: 'title', label: 'Name', type: 'localized-string' },
        { key: 'tagline', label: 'Tagline', type: 'localized-string', help: 'A short line under the name, e.g. “Baby & toddler”.' },
        { key: 'image', label: 'Picture', type: 'image', help: 'Square; shown inside the circle. Empty = the name on the pastel circle.' },
        { key: 'link', label: 'Link', type: 'string', placeholder: '/category/…' },
      ],
      default: [
        { title: { en: '0–2 years', bn: '০–২ বছর' }, tagline: { en: 'Baby & toddler', bn: 'শিশু' }, link: '/shop' },
        { title: { en: '3–5 years', bn: '৩–৫ বছর' }, tagline: { en: 'Little explorers', bn: 'ছোট্ট অভিযাত্রী' }, link: '/shop' },
        { title: { en: '6–8 years', bn: '৬–৮ বছর' }, tagline: { en: 'Early school', bn: 'স্কুলের শুরু' }, link: '/shop' },
        { title: { en: '9–12 years', bn: '৯–১২ বছর' }, tagline: { en: 'Big kids', bn: 'বড়রা' }, link: '/shop' },
        { title: { en: '12+ years', bn: '১২+ বছর' }, tagline: { en: 'Teens', bn: 'কিশোর' }, link: '/shop' },
      ],
    },
    { key: 'limit', label: 'Categories shown (automatic tiles)', type: 'number', default: 12 },
    ...SECTION_STYLE_FIELDS,
  ],
}
